import { Search } from 'lucide-react';
import { BLOG_CATEGORIES } from './blogCategories';

export default function BlogFilters({ category, setCategory, search, setSearch }) {
  return (
    <div className="flex flex-col gap-5 mb-12">
      <div className="relative max-w-md w-full">
        <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search articles..."
          className="w-full pl-10 pr-4 py-3 rounded-xl bg-secondary/40 border border-border/50 text-foreground text-sm font-inter placeholder:text-muted-foreground/60 focus:outline-none focus:border-primary/50 focus:ring-1 focus:ring-primary/20"
        />
      </div>
      <div className="flex flex-wrap gap-2">
        <button
          onClick={() => setCategory('All')}
          className={`px-4 py-2 rounded-lg text-xs font-inter font-semibold tracking-wide uppercase transition-all ${
            category === 'All'
              ? 'bg-primary text-primary-foreground'
              : 'bg-secondary/40 text-muted-foreground border border-border/50 hover:text-foreground hover:border-primary/40'
          }`}
        >
          All
        </button>
        {BLOG_CATEGORIES.map((c) => (
          <button
            key={c}
            onClick={() => setCategory(c)}
            className={`px-4 py-2 rounded-lg text-xs font-inter font-semibold tracking-wide uppercase transition-all ${
              category === c
                ? 'bg-primary text-primary-foreground'
                : 'bg-secondary/40 text-muted-foreground border border-border/50 hover:text-foreground hover:border-primary/40'
            }`}
          >
            {c}
          </button>
        ))}
      </div>
    </div>
  );
}